import { atom } from 'recoil';

export const errorCodesState = atom<Record<string, string>>({
  key: 'errorCodesState',
  default: {},
});

export const errorCodesLoadingState = atom<boolean>({
  key: 'errorCodesLoadingState',
  default: true,
});

export const errorCodesErrorState = atom<string>({
  key: 'errorCodesErrorState',
  default: '',
});
